"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userFactory = exports.userPhoneNumberFactory = void 0;
const Factory = require("factory.ts");
const uuid_1 = require("uuid");
const alert_preference_factory_1 = require("./alert-preference.factory");
const persona_factory_1 = require("./persona.factory");
const mobile_phone_factory_1 = require("../../Ngin/factories/mobile-phone.factory");
const profile_image_factory_1 = require("../../common/factories/profile-image.factory");
const mocks_1 = require("../../../mocks");
const email_address_factory_1 = require("./email-address.factory");
exports.userPhoneNumberFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    phone: mocks_1.persona.phone,
    validated: true,
});
exports.userFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    uri: Factory.each(i => `https://user.sportngin.com.dev/users/${i + 1}`),
    user_name: 'testuser',
    first_name: mocks_1.persona.first_name,
    last_name: mocks_1.persona.last_name,
    uuid: Factory.each(() => uuid_1.v4()),
    is_activated: true,
    external_identity_provider: false,
    password_last_updated_at: mocks_1.dates.date2000,
    email_addresses: email_address_factory_1.emailAddressFactory.buildList(1),
    pending_email_addresses: [],
    profile_images: profile_image_factory_1.profileImageFactory.buildList(1),
    phone_number: exports.userPhoneNumberFactory.build(),
    primary_email: 'test.primary@user.com',
    mobile_phone: mobile_phone_factory_1.mobilePhoneFactory.build(),
    alert_preferences: alert_preference_factory_1.alertPreferenceFactory.buildList(1),
    self_persona: persona_factory_1.personaFactory.build()
});
